export default class PatientDetails {
    id: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    bloodType: string
    phoneNumber: string;
    email: string
    address: string
    createdAt: string
    modifiedAt: string
    age: number
    nrOfExaminations: number

    constructor(
        id: string, firstName: string, lastName: string, birthDate: string, phoneNumber: string, email: string,
        address: string, createdAt: string, modifiedAt: string, bloodType: string, age: number, nrOfExaminations: number
    ) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.birthDate = birthDate;
        this.bloodType = bloodType;
        this.phoneNumber = phoneNumber;
        this.email = email;
        this.address = address;
        this.createdAt = createdAt
        this.modifiedAt = modifiedAt
        this.age = age
        this.nrOfExaminations = nrOfExaminations
    }
}